import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { timer, Subscription } from 'rxjs';

@Component({
  selector: 'app-course-countdown',
  templateUrl: './course-countdown.component.html',
  styleUrls: ['./course-countdown.component.scss'],
})
export class CourseCountdownComponent  implements OnInit, OnDestroy {

  @Input() labelClass: string = "";
  @Input() scheduledMsg!: string;
  @Input() fechaVencimiento!: string;
  @Input() displayTimeIcon: boolean = false;
  @Output() expirado = new EventEmitter<void>();

  dias = '00';
  horas = '00';
  minutos = '00';
  segundos = '00';
  mostrarCountdown = false;
  private subscripcion!: Subscription;

  constructor() { }

  ngOnInit() {
    if (this.fechaVencimiento) {
      this.iniciarCountdown();
    }
  }

  private iniciarCountdown() {
    const fechaFinal = this.parseFecha(this.fechaVencimiento);
    this.subscripcion = timer(0, 1000).subscribe(() => {
      this.actualizarTiempo(fechaFinal);
    });
  }

  private parseFecha(fechaString: string): Date {
    return new Date(fechaString.replace(' ', 'T'));
  }

  private actualizarTiempo(fechaFinal: Date) {
    const ahora = new Date();
    const diferencia = fechaFinal.getTime() - ahora.getTime();

    if (diferencia <= 0) {
      this.expirado.emit();
      // console.log(this.subscripcion)
      this.subscripcion?.unsubscribe();
      return;
    }

    this.mostrarCountdown = diferencia < (5 * 24 * 60 * 60 * 1000);

    const segundos = Math.floor((diferencia / 1000) % 60);
    const minutos = Math.floor((diferencia / (1000 * 60)) % 60);
    const horas = Math.floor((diferencia / (1000 * 60 * 60)) % 24);
    const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));

    this.dias = this.formatearTiempo(dias);
    this.horas = this.formatearTiempo(horas);
    this.minutos = this.formatearTiempo(minutos);
    this.segundos = this.formatearTiempo(segundos);
  }

  private formatearTiempo(tiempo: number): string {
    return tiempo < 10 ? `0${tiempo}` : `${tiempo}`;
  }

  ngOnDestroy() {
    this.subscripcion?.unsubscribe();
  }

}
